import React, { useState, useEffect } from 'react'
import ReadMoreButton from "./ReadMoreButton/ReadMoreButton"
import styles from './ReadMore.module.scss'
import AnimateHeight from 'react-animate-height'

const ReadMore = ({ text, openReadMoreHandler }) => {
  const minTextHeight = 78
  const [isFullTextVisible, setIsFullTextVisible] = useState(false)
  const [textHeight, setTextHeight] = useState(minTextHeight)
  const textLength = text.length
  const limit = 103

  useEffect(() => {
    if(text.length <= limit) {
      setTextHeight('auto')
    }
  }, [text])


  const getLimitedText = (text, limit) => {
    const limitWithoutReadMore = limit
    return text.substring(0, limitWithoutReadMore)
  }

  const onClickHandler = () => {
    setIsFullTextVisible(!isFullTextVisible)
    setTextHeight(isFullTextVisible ? minTextHeight : 'auto')
  }

  return (
    <div className={styles.readMoreTextWrapper}>
      <AnimateHeight
        id='example-panel'
        duration={ 500 }
        height={ textHeight }>
      <p>
        {text}
      </p>
      </AnimateHeight>
      <ReadMoreButton onClickHandler={onClickHandler} isFullTextVisible={isFullTextVisible}/>
    </div>
  )
}

export default ReadMore
